<template>
  <div>
    <vue-pdf
      v-for="i in numPages"
      :key="i"
      :src="src"
      :page="i"
      style="width: 100%"
    ></vue-pdf>
  </div>
</template>
<script>
import VuePdf from "vue-pdf";

export default {
  data: () => ({
    numPages: 0,
    src: ""
  }),
  components: {
    VuePdf
  },
  async mounted() {
    this.src = VuePdf.createLoadingTask(`../../../NxVet_20200103_v0.2.pdf`);
    let pdf = await this.src;
    this.numPages = pdf.numPages;
    console.log("numPages:" + this.numPages);
  }
};
</script>
